import {twMerge} from 'tailwind-merge';
import NavBarDynamicShadow from '../navigation/NavBarDynamicShadow';
import QuizNavButtons from './QuizNavButtons';
import BaseButton from '../BaseButton';
import LogoIcon from '../LogoIcon';
import QuizIcon from './QuizIcon';

type Props = {
  contentClassName?: string;
  className?: string;
  hideShadow?: boolean;
};

const QuizNavBar = ({className, contentClassName, hideShadow}: Props) => {
  return (
    <nav
      className={twMerge(
        'sticky w-full top-0 z-10 flex justify-center items-center h-20 backdrop-blur-sm bg-[rgb(255_255_255_/_0.9)] dark:bg-[rgb(22_15_25_/_0.85)]',
        className
      )}
    >
      <div
        className={twMerge(
          'relative flex grow max-w-[1600px] justify-between align-center px-(--page-padding) max-[700px]:px-3',
          contentClassName
        )}
      >
        <div className="flex items-center gap-4 max-[600px]:gap-2">
          <BaseButton
            href="/"
            aria-label="Humbo"
            buttonVariant="text"
            className="mb-1 max-[700px]:ml-1 rounded-lg h-full px-3 py-0"
          >
            <LogoIcon width={22.5} height={25.5} />
          </BaseButton>

          <div className="w-[2px] h-8 bg-(--inactive-color)" />

          <BaseButton href="/quiz" buttonVariant="text" className="rounded-lg h-full px-3 py-0 gap-2">
            <QuizIcon />
            <span className="text-2xl font-medium font-heading text-(--dynamic-purple)">Quiz</span>
          </BaseButton>
        </div>

        <QuizNavButtons />
      </div>

      {hideShadow ? null : <NavBarDynamicShadow />}
    </nav>
  );
};

export default QuizNavBar;
